import React from 'react';
import EditSmsSettingComponent from '../../../Components/SmsSetting/EditSmsSetting';

export default function EditSmsSetting() {
    return (
        <div className='page-body'>
            <EditSmsSettingComponent />
        </div>
    );
}